import { Drawer } from "rsuite";
import "rsuite/dist/rsuite.min.css";
export const AESClientWebsiteDrawer = ({
  open,
  setOpen,
  title,
  children,
  size = "md",
  backdrop = true,
  closeButton = true,
  HeaderClassName,
  close,
  ...additional
}) => {
  return (
    <Drawer
      open={open}
      backdrop={backdrop}
      size={size}
      onClose={() => setOpen(false)}
      containerStyle={{ height: "100%" }}
      {...additional}
    >
      <Drawer.Header className={HeaderClassName} closeButton={closeButton}>
        <Drawer.Title>{title}</Drawer.Title>

        {close && (
          <Drawer.Actions>
            <button
              className="btn btn-default"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
          </Drawer.Actions>
        )}
      </Drawer.Header>

      <Drawer.Body>{children}</Drawer.Body>
    </Drawer>
  );
};